if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* 8888 Abundance: filter product media by selected color/variant */
(function () {
  const STYLE_ID = 'abundance-variant-media-filter-style';
  const COLOR_WORDS = [
    'black', 'white', 'navy', 'blue', 'royal', 'aqua', 'brown', 'natural', 'green', 'forest',
    'teal', 'pink', 'mauve', 'cancun', 'gray', 'grey', 'red', 'purple', 'yellow', 'cream',
    'beige', 'orange', 'olive', 'maroon'
  ];

  const NOISE_WORDS = new Set([
    'solid', 'blend', 'triblend', 'tri', 'heather', 'vintage', 'dyed', 'g', 'shirt', 't', 'tee',
    'tshirt', 'front', 'back', 'side', 'mockup', 'product', 'unisex', 'womens', 'women', 'mens',
    'men', 'tank', 'top', 'short', 'sleeve', 'relaxed', 'fitted', 'micro', 'rib', 'high', 'waisted'
  ]);

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = '.product__media-item[hidden], .thumbnail-list__item[hidden]{display:none!important;}';
    document.head.appendChild(style);
  }

  function normalize(value) {
    let text = String(value || '').toLowerCase();
    for (let i = 0; i < 2; i++) {
      try { text = decodeURIComponent(text); } catch (e) { break; }
    }
    return text
      .replace(/https?:\/\//g, ' ')
      .replace(/[?#].*$/g, ' ')
      .replace(/\.(jpg|jpeg|png|webp|gif|avif|svg)/g, ' ')
      .replace(/[_\-.\/]+/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tokens(value) {
    return normalize(value).split(' ').filter(Boolean);
  }

  function selectedVariant(root) {
    const node = root.querySelector('variant-selects [data-selected-variant]') || document.querySelector('variant-selects [data-selected-variant]');
    if (!node || !node.textContent.trim()) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function getSelectedColor(root) {
    const picker = root.querySelector('variant-selects') || document.querySelector('variant-selects');
    if (!picker) return '';

    const groups = Array.from(picker.querySelectorAll('fieldset, .product-form__input'));
    for (const group of groups) {
      const label = normalize(group.querySelector('legend, label')?.textContent || '');
      if (!/(^| )colou?r( |$)/.test(label)) continue;

      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value || checked.getAttribute('aria-label') || '';

      const select = group.querySelector('select');
      if (select) return select.options[select.selectedIndex]?.text || select.value || '';

      const selectedLabel = group.querySelector('[data-selected-value]');
      if (selectedLabel) return selectedLabel.textContent || '';
    }

    const variant = selectedVariant(root);
    if (variant && Array.isArray(variant.options)) {
      for (const optionValue of variant.options) {
        const optionTokens = tokens(optionValue);
        if (optionTokens.some((token) => COLOR_WORDS.includes(token))) return optionValue;
      }
      return variant.options[0] || '';
    }

    return '';
  }

  function aliasesForColor(color) {
    const value = normalize(color);
    const set = new Set([value]);
    const t = tokens(value).filter((token) => !NOISE_WORDS.has(token));
    t.forEach((token) => set.add(token));

    if (value.includes('white')) { set.add('white'); set.add('solid white'); set.add('white fleck'); }
    if (value.includes('black')) set.add('black');
    if (value.includes('navy')) { set.add('navy'); set.add('heather navy'); }
    if (value.includes('royal')) { set.add('royal'); set.add('true royal'); set.add('vintage royal'); set.add('blue'); }
    if (value.includes('aqua')) { set.add('aqua'); set.add('turquoise'); }
    if (value.includes('brown')) set.add('brown');
    if (value.includes('natural')) { set.add('natural'); set.add('cream'); }
    if (value.includes('forest') || value.includes('green')) { set.add('forest green'); set.add('green'); set.add('forest'); }
    if (value.includes('deep teal') || value.includes('teal')) { set.add('deep teal'); set.add('teal'); }
    if (value.includes('pink')) { set.add('pink'); set.add('hot pink'); }
    if (value.includes('mauve')) set.add('mauve');
    if (value.includes('cancun')) set.add('cancun');

    return Array.from(set).filter(Boolean).sort((a, b) => b.length - a.length);
  }

  function textForMedia(item) {
    const image = item.querySelector('img');
    return normalize([
      image?.getAttribute('alt'),
      image?.getAttribute('src'),
      image?.getAttribute('srcset'),
      image?.currentSrc,
      item.getAttribute('aria-label'),
      item.dataset.mediaId
    ].join(' '));
  }

  function matchesColor(item, color) {
    const mediaText = textForMedia(item);
    if (!mediaText) return false;
    const aliases = aliasesForColor(color);

    if (aliases.some((alias) => alias && mediaText.includes(normalize(alias)))) return true;

    const important = tokens(color).filter((token) => !NOISE_WORDS.has(token));
    if (important.length && important.every((token) => mediaText.includes(token))) return true;

    return false;
  }

  function getFeaturedMediaId(root) {
    const variant = selectedVariant(root);
    const id = variant?.featured_media?.id || variant?.featured_media?.preview_image?.id;
    return id ? String(id) : '';
  }

  function isFeaturedItem(item, featuredId) {
    return Boolean(featuredId && item.dataset.mediaId && item.dataset.mediaId.endsWith(`-${featuredId}`));
  }

  function applyFilter(root) {
    injectStyle();
    const productInfo = root?.closest?.('product-info') || document.querySelector('product-info');
    const scope = productInfo || document;
    const color = getSelectedColor(scope);
    const gallery = scope.querySelector('media-gallery') || document.querySelector('media-gallery');
    if (!gallery || !color) return;

    const featuredId = getFeaturedMediaId(scope);
    const slides = Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]'));
    if (!slides.length) return;

    let visibleSlides = slides.filter((slide) => isFeaturedItem(slide, featuredId) || matchesColor(slide, color));

    if (!visibleSlides.length && featuredId) {
      visibleSlides = slides.filter((slide) => isFeaturedItem(slide, featuredId));
    }

    if (!visibleSlides.length) return;

    const visibleIds = new Set(visibleSlides.map((slide) => slide.dataset.mediaId));
    slides.forEach((slide) => {
      const shouldShow = visibleIds.has(slide.dataset.mediaId);
      slide.hidden = !shouldShow;
      slide.classList.toggle('abundance-media-hidden', !shouldShow);
      if (!shouldShow) slide.classList.remove('is-active');
    });

    const thumbnails = Array.from(gallery.querySelectorAll('.thumbnail-list__item[data-target]'));
    thumbnails.forEach((thumb) => {
      const shouldShow = visibleIds.has(thumb.dataset.target);
      thumb.hidden = !shouldShow;
      thumb.classList.toggle('abundance-media-hidden', !shouldShow);
      if (!shouldShow) thumb.querySelector('button')?.removeAttribute('aria-current');
    });

    const firstVisible = visibleSlides.find((slide) => isFeaturedItem(slide, featuredId)) || visibleSlides[0];
    if (firstVisible) {
      gallery.setActiveMedia?.(firstVisible.dataset.mediaId, true);
      firstVisible.classList.add('is-active');
      const thumb = gallery.querySelector(`.thumbnail-list__item[data-target="${firstVisible.dataset.mediaId}"] button`);
      thumb?.setAttribute('aria-current', 'true');
    }

    gallery.querySelectorAll('.slider-counter--total').forEach((node) => { node.textContent = String(visibleSlides.length); });
    gallery.querySelectorAll('.slider-counter--current').forEach((node) => { node.textContent = '1'; });
  }

  function scheduleFilter(root) {
    window.clearTimeout(window.__abundanceVariantMediaFilterTimer);
    window.__abundanceVariantMediaFilterTimer = window.setTimeout(() => applyFilter(root || document), 80);
  }

  document.addEventListener('DOMContentLoaded', () => scheduleFilter(document));
  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) scheduleFilter(event.target.closest('product-info') || document);
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('variant-selects')) scheduleFilter(event.target.closest('product-info') || document);
  });

  if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
      scheduleFilter(document.getElementById(`MainProduct-${event?.data?.sectionId}`) || document);
    });
  }

  document.addEventListener('product-info:loaded', (event) => scheduleFilter(event.target));
})();
